module.exports = __webpack_public_path__ + "static/images/eye.874548882529bdca2d338ed6800f05d4.svg";